import { render, staticRenderFns } from "./slproducttender-add-or-update.vue?vue&type=template&id=7e8ec3fe&"
import script from "./slproducttender-add-or-update.vue?vue&type=script&lang=js&"
export * from "./slproducttender-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports